import React from 'react'
import "./style.css"

function Header() {
  return (
    <div className="container">
        <div>My Todo List</div>
        <div>React</div>
    </div>
  )
}

export default Header